const STAFF_SESSION_KEY = 'scheduleapp_local_session';
const CLIENT_SESSION_KEY = 'scheduleapp_client_session';
const ADMIN_SESSION_KEY = 'scheduleapp_admin_session';

function readToken(key) {
  try {
    return String(localStorage.getItem(key) || '').trim() || null;
  } catch {
    return null;
  }
}

function writeToken(key, token) {
  try {
    if (token) localStorage.setItem(key, token);
    else localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export function getLocalSessionToken() {
  return readToken(STAFF_SESSION_KEY);
}

export function setLocalSessionToken(token) {
  writeToken(STAFF_SESSION_KEY, token);
}

export function clearLocalSessionToken() {
  writeToken(STAFF_SESSION_KEY, null);
}

export function getClientSessionToken() {
  return readToken(CLIENT_SESSION_KEY);
}

export function setClientSessionToken(token) {
  writeToken(CLIENT_SESSION_KEY, token);
}

export function clearClientSessionToken() {
  writeToken(CLIENT_SESSION_KEY, null);
}

export function getAdminSessionToken() {
  return readToken(ADMIN_SESSION_KEY);
}

export function setAdminSessionToken(token) {
  writeToken(ADMIN_SESSION_KEY, token);
}

export function clearAdminSessionToken() {
  writeToken(ADMIN_SESSION_KEY, null);
}

export async function getApiToken() {
  const local = getLocalSessionToken();
  if (!local) throw new Error('Not signed in');
  return local;
}

export async function tryGetApiToken() {
  return getLocalSessionToken();
}

export async function getClientApiToken() {
  const local = getClientSessionToken();
  if (!local) throw new Error('Not signed in');
  return local;
}

export async function tryGetClientApiToken() {
  return getClientSessionToken();
}

export async function getAdminApiToken() {
  const local = getAdminSessionToken();
  if (!local) throw new Error('Not signed in');
  return local;
}

export async function tryGetAdminApiToken() {
  return getAdminSessionToken();
}

export function decodeLocalSession(token) {
  if (!token || !token.startsWith('local.')) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const padded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(padded);
    const payload = JSON.parse(json);
    if (!payload?.uid || !payload.exp || payload.exp < Date.now()) return null;
    return payload;
  } catch {
    return null;
  }
}
